import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('bi_favorite_question', {
  question_id: '',
  created_at: '',
  question_text: '',
})
